import * as f from './utils/f';
// import {fonts} from "@/utils/f";

// f.fonts();
f.sizes();
f.margins();
f.borders();

